// extracted by mini-css-extract-plugin
export default {"news":"Yr1ItAm_K8yFex9z7y8U"};